import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiFragment, RecordType, sessionStorageHelper, Zone, ZoneId, ZonesService } from '@stylehaven/components';
import { MiddlewareService } from './middleware.abstract.service';

@Injectable({ providedIn: 'root' })
export class AccessibleMiddleware implements MiddlewareService {
    constructor(private zonesService: ZonesService) {}

    /*
     * This blocks access to concept record that are not in zones of the user
     * At the time of 21/01/2022 the backend does not block this yet
     * Can be removed once this does happen inherently
     */
    public annotate(record: ApiFragment): Observable<ApiFragment> {
        const recordType: RecordType = record.getRecordType();

        if (recordType == RecordType.Record || recordType === RecordType.Mh2Collection) {
            return this.zonesService.zones$.pipe(map(zones => this.handleRecordAccessibility(record, zones)));
        }

        return of(record);
    }

    private handleRecordAccessibility(record: ApiFragment, zones: Zone[]): ApiFragment {
        if (record.isPublished()) {
            return record;
        }

        const userZoneIds: ZoneId[] = zones.map(zone => zone.Id);
        const recordZoneId: ZoneId | null = record.getZoneId();

        if (!recordZoneId || sessionStorageHelper.has('shareToken') || userZoneIds.includes(recordZoneId)) {
            return record;
        }

        throw new Error(`Concept Record with id ${record.getFragmentId()} is not in zone of user`);
    }
}
